import { render, staticRenderFns } from "./ScaleQuestionContentTab.vue?vue&type=template&id=4be8a193&"
import script from "./ScaleQuestionContentTab.vue?vue&type=script&lang=js&"
export * from "./ScaleQuestionContentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports